import React, { useEffect, useState } from 'react'
import style from "css/address.module.css";
import { ReactComponent as Close } from "asset/common/close_popup.svg";
import { ReactComponent as TagClose } from "asset/address/tag_close.svg";
import { Button, ConfigProvider, Divider, Input, Modal, Select, Space } from 'antd';
import InfoPopupItem from './infoPopupItem';
import axios from 'axios';
import { SettingOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

function InfoPopup({ isOpen, isRefresh, closeEvent, openTagPopup, info, tagList }) {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [type, setType] = useState("");
    const [data, setData] = useState({});
    const [tags, setTags] = useState([]);
    const colorTemplate = [
        { txt_color: "#65a5e0", bg_color: "#dcedfc" },
        { txt_color: "#1cb691", bg_color: "#def5e9" },
        { txt_color: "#fd9800", bg_color: "#fef0d4" }
    ]

    useEffect(() => {
        if (isOpen) {
            if (info !== undefined && info !== null) {
                setData(info);
                setType("edit");
            } else {
                setData({});
                setType("add")
            }
            setTags(tagList);
        }
    }, [info, isOpen, tagList]);

    const labelToKey = (list) => {
        let result = [];
        tags.forEach(el => {
            const label = el.label;
            const obj = list.filter(tag => tag === label);

            if (obj.length > 0) {
                result.push(el);
            }
        });
        return result;
    }

    const saveEvent = () => {
        setIsLoading(true);
        const url = "/address/info";
        let axiosData = {
            name: data.name,
            email: data.email,
            tel: data.tel,
            memo: data.memo,
        }

        if (data.tag.length > 0) {
            axiosData.tags = labelToKey(data.tag);
        }

        if (type === "add") {
            axios.post(url, axiosData)
                .then(
                    res => {
                        if (res.status === 200) {
                            isRefresh();
                            closeEvent();
                        }
                    }
                )
                .finally(() => {
                    setIsLoading(false);
                })
        } else if (type === "edit") {
            axiosData.address_id = data.key;
            axiosData.favorite_yn = data.favorite;

            if (info.tag.length > 0) {
                axiosData.origin_tags = labelToKey(info.tag);
            }

            axios.put(url, axiosData)
                .then(
                    res => {
                        if (res.status === 200) {
                            isRefresh();
                            closeEvent();
                        }
                    }
                )
                .finally(() => {
                    setIsLoading(false);
                })
        }
    }

    const deleteTag = (label) => {
        const result = data.tag.filter(el => el !== label);
        setData({
            ...data,
            tag: result
        });
    }

    const tagRender = ({ label, value }) => {
        const obj = tags.filter(el => el.label === label)[0];
        const color = colorTemplate[Math.floor(Math.random() * 3)];
        return (
            <div
                className={style.info_popup_select_item}
                style={{
                    color: obj === undefined ? color.txt_color : obj.txt_color,
                    backgroundColor: obj === undefined ? color.bg_color : obj.bg_color,
                    fill: obj === undefined ? color.txt_color : obj.txt_color
                }}
                key={value}
            >
                {label}
                <TagClose
                    className='cursor'
                    onClick={() => deleteTag(label)}
                />
            </div>
        );
    };

    const filterOption = (input, option) => {
        return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };

    const valueRender = (list) => {
        let arr = [];
        list.forEach(tag => {
            const obj = tags.filter(el => el.label === tag)[0];
            const color = colorTemplate[Math.floor(Math.random() * 3)];
            if (obj === undefined) {
                arr.push({
                    label: tag,
                    value: tag
                });
                setTags([
                    ...tags,
                    {
                        label: tag,
                        txt_color: color.txt_color,
                        bg_color: color.bg_color
                    }
                ]);
            } else {
                arr.push({
                    label: obj.label,
                    value: obj.label,
                });
            }
        });
        return arr;
    }

    const selectTag = (list) => {
        let result = [];
        list.forEach(value => {
            let obj = tags.filter(el => el.label === value)[0];
            if (obj === undefined) {
                result.push(value);
            } else {
                result.push(obj.label);
            }
        });
        setData({
            ...data,
            tag: result
        });
    }

    const selectItemRender = (menu) => {
        return (
            <>
                {menu}
                <Divider style={{ margin: '8px 0' }} />
                <Space className={style.info_popup_select_setting_btn} >
                    <SettingOutlined
                        className='cursor'
                        onClick={
                            () => {
                                closeEvent();
                                openTagPopup();
                            }
                        }
                    />
                </Space>
            </>
        )
    }

    return (
        <Modal
            open={isOpen}
            footer={
                <div className={style.info_popup_btn_area}>
                    <ConfigProvider
                        theme={{
                            components: {
                                Button: {
                                    colorPrimaryHover: "#1cb691",
                                    colorPrimaryActive: "#1cb691",
                                }
                            }
                        }}
                    >
                        <Button
                            onClick={() => closeEvent()}
                        >
                            {t("BTN.CANCEL")}
                        </Button>
                    </ConfigProvider>
                    <Button
                        type='primary'
                        onClick={() => saveEvent()}
                        loading={isLoading}
                    >
                        {t("BTN.SAVE")}
                    </Button>
                </div>
            }
            closable={false}
            width={514}

            centered
        >
            <div className={style.info_popup_container}>
                <div className={style.info_popup_header}>
                    <p className={style.info_popup_title}>
                        {type === "add" ? t("LABEL.TITLE.ADD_CONTACT") : t("LABEL.TITLE.MODIFY_CONTACT")}
                    </p>
                    <Close
                        className={style.info_popup_close}
                        onClick={() => closeEvent()}
                    />
                </div>

                <div className={style.info_popup_item_area}>
                    <InfoPopupItem
                        title={t("LIST.NAME")}
                        content={
                            <Input
                                className={style.info_popup_item_input}
                                type='primary'
                                value={data?.name}
                                onChange={
                                    e => {
                                        setData({
                                            ...data,
                                            name: e.target.value
                                        })
                                    }
                                }
                            />
                        }
                    />

                    <InfoPopupItem
                        title={t("LIST.EMAIL")}
                        content={
                            <Input
                                className={style.info_popup_item_input}
                                type='primary'
                                value={data?.email}
                                onChange={
                                    e => {
                                        setData({
                                            ...data,
                                            email: e.target.value
                                        })
                                    }
                                }
                            />
                        }
                    />
                </div>

                <div className={style.info_popup_item_area}>
                    <InfoPopupItem
                        title={t("LIST.PHONE")}
                        content={
                            <Input
                                className={style.info_popup_item_input}
                                type='primary'
                                value={data?.tel}
                                onChange={
                                    e => {
                                        setData({
                                            ...data,
                                            tel: e.target.value
                                        })
                                    }
                                }
                            />
                        }
                    />

                    <InfoPopupItem
                        title={t("LIST.GROUP")}
                        content={
                            <ConfigProvider
                                theme={{
                                    components: {
                                        Select: {
                                            colorPrimary: "#fff",
                                            colorPrimaryHover: "#1cb691",
                                            controlItemBgActive: "#1cb691",
                                            controlItemBgHover: "#1cb691",
                                            // colorText: "#current",
                                        }
                                    }
                                }}
                            >
                                <Select
                                    className={style.info_popup_select}
                                    mode="tags"
                                    value={
                                        data.tag !== undefined && data.tag.length > 0
                                            ? valueRender(data.tag)
                                            : []
                                    }
                                    options={(tags || []).map(
                                        el => ({
                                            label: el.label,
                                            value: el.label
                                        })
                                    )}
                                    onChange={selectTag}
                                    tagRender={tagRender}
                                    notFoundContent={null}
                                    filterOption={filterOption}
                                    maxTagCount={'responsive'}
                                    dropdownRender={(menu) => selectItemRender(menu)}
                                />
                            </ConfigProvider>
                        }
                    />
                </div>

                <div className={style.info_popup_memo_area}>
                    <InfoPopupItem
                        title={t("LIST.MEMO")}
                        content={
                            <Input
                                className={style.info_popup_item_memo}
                                type='primary'
                                value={data?.memo}
                                onChange={
                                    e => {
                                        setData({
                                            ...data,
                                            memo: e.target.value
                                        })
                                    }
                                }
                            />
                        }
                    />
                </div>
            </div>
        </Modal >
    )
}

export default InfoPopup
